import { render, staticRenderFns } from "./AdminOrderImport.vue?vue&type=template&id=b363c964&scoped=true"
import script from "./AdminOrderImport.vue?vue&type=script&lang=js"
export * from "./AdminOrderImport.vue?vue&type=script&lang=js"
import style0 from "./AdminOrderImport.vue?vue&type=style&index=0&id=b363c964&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b363c964",
  null
  
)

export default component.exports